import type { ReactNode } from 'react'

import { NumberIcon } from '@twisto/components/atoms/number-icon'

import { BaseListItem } from '../base-list'
import { useList } from '../list.context'

import * as styles from './numbered-list-item.styles'

type Props = {
  children: ReactNode
}

export const NumberedListItem = ({ children }: Props) => {
  const { index } = useList()

  return (
    <BaseListItem
      hasGap
      data-testid="numbered-list-item"
      icon={<NumberIcon css={styles.icon} value={index + 1} />}
    >
      {children}
    </BaseListItem>
  )
}
